export {
    HelpCentersManagementPage,
    HelpCentersManagementResource,
    callToActionUrlText,
    authPageMessage,
} from './ui/help-centers-management-page';
